<template>
    <div class="relative ml-auto flex h-full items-stretch">
        <template v-if="isMfaValidated">
            <!-- Desktop nav links -->
            <RouterLink
                class="nav-link hidden lg:flex"
                :class="{ 'active-menu-item': $route.path.startsWith('/id-verification-review') }"
                to="/id-verification-review"
            >
                ID verification review
            </RouterLink>
            <a
                class="nav-link hidden lg:flex"
                :class="{ 'active-menu-item': $route.path === '/wireinstructionrequests' }"
                href="/wireinstructionrequests"
            >
                Wire requests
            </a>
            <RouterLink
                class="nav-link hidden lg:flex"
                :class="{ 'active-menu-item': $route.path === '/payments/failedPayments' }"
                to="/payments/failedPayments"
            >
                Paused payments
            </RouterLink>
        </template>

        <div class="flex items-center px-4">
            <DsMenu
                v-model:open="isMenuOpen"
                align="end"
                side="bottom"
                :sideOffset="8"
            >
                <template #menuTrigger>
                    <button
                        class="user-menu-trigger"
                        type="button"
                    >
                        <DsAvatarInitials
                            :firstName
                            :lastName
                            size="sm"
                        />
                        <span class="hidden sm:inline">{{ firstName }}</span>
                        <DsIcon
                            class="hidden legacy-md:block"
                            icon="fa-solid fa-chevron-down"
                            size="sm"
                            :style="{
                                transform: isMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 200ms ease-in-out',
                                transformOrigin: 'center',
                            }"
                        />
                    </button>
                </template>

                <!-- Nav items folded in on small screens -->
                <DsMenuGroup v-if="isMfaValidated && !isLarge">
                    <DsMenuOption @click="router.push('/id-verification-review')">ID verification review</DsMenuOption>
                    <DsMenuOption href="/wireinstructionrequests">Wire requests</DsMenuOption>
                    <DsMenuOption @click="router.push('/payments/failedPayments')">Paused payments</DsMenuOption>
                </DsMenuGroup>

                <DsMenuGroup>
                    <DsMenuOption
                        leading="fa-regular fa-arrow-right-from-bracket"
                        @click="currentUserService.logout()"
                    >
                        Logout
                    </DsMenuOption>
                </DsMenuGroup>
            </DsMenu>
        </div>
    </div>
</template>

<script setup lang="ts">
import { isLarge } from '@/components/Composables/MobileScreenDetection';
import { useCurrentUserService } from '@/services/current-user.service';
import DsAvatarInitials from '@ds/avatar/DsAvatarInitials.vue';
import DsIcon from '@ds/DsIcon.vue';
import DsMenu from '@ds/menu/DsMenu.vue';
import DsMenuGroup from '@ds/menu/DsMenuGroup.vue';
import DsMenuOption from '@ds/menu/DsMenuOption.vue';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const currentUserService = useCurrentUserService();

const isMenuOpen = ref(false);

const isMfaValidated = computed(() => currentUserService.currentUserMeta?.mfaValidated);

const firstName = computed(() => currentUserService.currentUser?.name?.split(' ')[0] ?? '');
const lastName = computed(() => currentUserService.currentUser?.name?.split(' ').slice(1).join(' ') ?? '');

defineSlots<{
    csrfField(): void;
    warning(): void;
    rightNavigation(): void;
}>();
</script>

<style scoped>
.nav-link {
    @apply relative flex items-center border-none bg-transparent px-4 text-content-md font-medium text-content-secondary no-underline transition-colors hover:bg-ds-gray-100;
}

.active-menu-item {
    @apply text-content-primary;
}

.active-menu-item::after {
    content: '';
    @apply absolute bottom-0 left-0 right-0 h-0.5 bg-ds-primary-900;
}

.user-menu-trigger {
    @apply flex cursor-pointer items-center gap-2 border-none bg-transparent text-content-md font-medium text-content-secondary transition-colors hover:text-content-primary;
}
</style>
